<script setup lang="ts">
import { computed, useTemplateRef } from "vue";

defineProps<{ text: string }>();

const rootRef = useTemplateRef("root");
const long = computed(() => rootRef.value && rootRef.value.scrollWidth > rootRef.value.offsetWidth);
</script>

<template>
  <div class="middle-ellipsis">
    <div ref="root" class="left">
      {{ text }}
    </div>
    <div v-if="long" class="right">
      {{ text }}
    </div>
  </div>
</template>

<style lang="scss">
@use "@/styles/mixins/utils";

.middle-ellipsis {
  display: flex;

  .left {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .right {
    width: 100%; // same width as .left
    overflow: hidden;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
